import { Action, ApplicationState, Role } from "./types";
import { DEFAULT_PERMISSIONS, CONSUMER_DURABLES_LOAN_PERMISSIONS, PRODUCT_TYPE_BASED_PERMISSIONS } from "./permissions";
import { PRODUCT_TYPES } from "../applications/config";

export const isActionAllowed = (
  role: Role,
  state: ApplicationState | null,
  action: Action,
  productType?: string,
): boolean => {
  // Check role-based default actions if no state is provided
  if (!state) {
    return DEFAULT_PERMISSIONS[role]?.includes(action) || false;
  }

  if (state && productType) {
    const productTypePermissions = PRODUCT_TYPE_BASED_PERMISSIONS[PRODUCT_TYPES[productType as keyof typeof PRODUCT_TYPES]];

    if (productTypePermissions) {
      const statePermissions = productTypePermissions[role]?.[state];
      return statePermissions?.includes(action) || false;
    }
  }

  // Check state-based permissions in the PERMISSIONS object
  const statePermissions = CONSUMER_DURABLES_LOAN_PERMISSIONS[role]?.[state];
  return statePermissions?.includes(action) || false;
};
